import {ContactType, PhoneType} from "./api/mindpath";
import {Schema} from "./api";
import {Address} from "./address";

export * from './action.type';
export * from './message-codes';
export * from './api';
export * from './address';

export function genPhone(type: PhoneType, number: string, isPrimary = true): Schema<'PhoneContact'> {
  let phoneNumber = number;
  if (phoneNumber.length === 11 && phoneNumber.startsWith('1')) {
    phoneNumber = phoneNumber.slice(1);
  }
  return {
    contactableType: ContactType.Phone,
    isPrimary,
    number: phoneNumber,
    type
  }
}

export function genEmail(email: string, isPrimary = true): Schema<'EmailContact'> {
  return {
    contactableType: ContactType.Email,
    address: email,
    isPrimary
  }
}

export function genAddress(addr: Address, isPrimary = true): Schema<'AddressContact'> {
  return {
    contactableType: ContactType.Address,
    address: addr,
    isPrimary
  }
}
